"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundTo = void 0;
const roundTo = (number, precision) => {
    return Math.round(number * Math.pow(10, precision)) / Math.pow(10, precision);
};
exports.roundTo = roundTo;
